var path = '/app/components/staticMap/staticmap.html';
var html = "<div class=\"rounded\" style=\"overflow: hidden;\">\n  <img class=\"rounded centered float-lg-right\" ng-src={{ctrl.mapUrl}} />\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;